export default __webpack_public_path__ + "static/media/pizza4.1cf1fdc1.jpg";